export namespace FeatureFlags {
  export const EXTEND_DEACTIVATION = 'extendDeactivation';
  export const STUDENT_MANAGEMENT = 'adminStudentManagement';
  export const STUDENT_DATA_EXPORT = 'studentDataExport';
  export const MULTIPLE_IEPS = 'multipleIEPs';
  export const SUBSCRIPTION_MANAGEMENT = 'subscriptionManagement';
}

export type FeatureFlagName = typeof FeatureFlags[keyof typeof FeatureFlags];
